import { Navigate, createBrowserRouter } from "react-router-dom";
import { ADMIN_ROLES } from "@glow-price/shared";

import { DashboardLayout } from "./pages/DashboardLayout";
import { DashboardPage } from "./pages/DashboardPage";
import { LoginPage } from "./pages/LoginPage";
import { BrandsPage } from "./pages/BrandsPage";
import { CategoriesPage } from "./pages/CategoriesPage";
import { StandardProductsPage } from "./pages/StandardProductsPage";
import { ChannelsPage } from "./pages/ChannelsPage";
import { ChannelProductsPage } from "./pages/ChannelProductsPage";
import { ChannelProductsMatrixPage } from "./pages/ChannelProductsMatrixPage";
import { ChannelScrapersPage } from "./pages/ChannelScrapersPage";
import { PriceSnapshotsPage } from "./pages/PriceSnapshotsPage";
import { FlashSalesPage } from "./pages/FlashSalesPage";
import { HomeEditorialPage } from "./pages/HomeEditorialPage";
import { EditorialTagsPage } from "./pages/EditorialTagsPage";
import { AffiliateNetworksPage } from "./pages/AffiliateNetworksPage";
import { ChannelAffiliateConfigsPage } from "./pages/ChannelAffiliateConfigsPage";
import { OutboundClicksPage } from "./pages/OutboundClicksPage";
import { AffiliateOrdersPage } from "./pages/AffiliateOrdersPage";
import { CommissionSettlementsPage } from "./pages/CommissionSettlementsPage";
import { AuditLogsPage } from "./pages/AuditLogsPage";
import { LegalDocsPage } from "./pages/LegalDocsPage";
import { SystemSettingsPage } from "./pages/SystemSettingsPage";
import { AdminUsersPage } from "./pages/AdminUsersPage";
import { ChangePasswordPage } from "./pages/ChangePasswordPage";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { RoleGuard } from "./components/RoleGuard";

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      // Phase 7: Dashboard is the default landing page after login.
      { index: true, element: <DashboardPage /> },
      { path: "/dashboard", element: <DashboardPage /> },
      { path: "/brands", element: <BrandsPage /> },
      { path: "/categories", element: <CategoriesPage /> },
      { path: "/standard-products", element: <StandardProductsPage /> },
      { path: "/channels", element: <ChannelsPage /> },
      { path: "/channel-products", element: <ChannelProductsPage /> },
      { path: "/channel-products-matrix", element: <ChannelProductsMatrixPage /> },
      { path: "/channel-scrapers", element: <ChannelScrapersPage /> },
      { path: "/price-snapshots", element: <PriceSnapshotsPage /> },
      { path: "/flash-sales", element: <FlashSalesPage /> },
      { path: "/home-editorial", element: <HomeEditorialPage /> },
      { path: "/editorial-tags", element: <EditorialTagsPage /> },
      { path: "/affiliate-networks", element: <AffiliateNetworksPage /> },
      { path: "/channel-affiliate-configs", element: <ChannelAffiliateConfigsPage /> },
      { path: "/outbound-clicks", element: <OutboundClicksPage /> },
      { path: "/affiliate-orders", element: <AffiliateOrdersPage /> },
      { path: "/commission-settlements", element: <CommissionSettlementsPage /> },
      { path: "/audit-logs", element: <AuditLogsPage /> },
      { path: "/legal-docs", element: <LegalDocsPage /> },
      // Phase 6D-2: 通用 site_settings JSON 编辑器（superadmin / editor only）
      {
        path: "/system-settings",
        element: (
          <RoleGuard roles={[ADMIN_ROLES.SUPERADMIN, ADMIN_ROLES.EDITOR]}>
            <SystemSettingsPage />
          </RoleGuard>
        ),
      },
      // Phase 6D-1: admin account management — superadmin-only. The API also
      // enforces this; RoleGuard here keeps non-superadmins from even seeing
      // the page chrome.
      {
        path: "/admin-users",
        element: (
          <RoleGuard roles={[ADMIN_ROLES.SUPERADMIN]}>
            <AdminUsersPage />
          </RoleGuard>
        ),
      },
      // Self-service password change is available to every authenticated role.
      { path: "/me/change-password", element: <ChangePasswordPage /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
